import { Grid, makeStyles } from '@material-ui/core';
import { diaDaSemana, formatDate } from 'app/utils/dataUtils';
import { getCurrencySemSinalMonetario } from 'app/utils/monetarioUtil';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  contentExtratoInfo: {
    fontSize: '18px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    textAlign: 'left',
  },
}));

const ContentInformacaoExtrato = ({ data, descricao, valor }) => {
  const classes = useStyles();

  return (
    <Grid container spacing={3} className={classes.contentExtratoInfo}>
      <Grid item lg={12} xl={12}>
        {`${formatDate(data)} - ${diaDaSemana(data)}`}
      </Grid>
      <Grid item lg={12} xl={12}>
        {descricao}
      </Grid>
      <Grid item lg={12} xl={12} style={{ color: valor < 0 ? 'red' : 'blue' }}>
        {`${getCurrencySemSinalMonetario(valor)}`}
      </Grid>
    </Grid>
  );
};

export default ContentInformacaoExtrato;
